/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import { useEffect} from "react";

/**
 * Fetches and executes the minified SCUI code from the url that is constructed in the function.
 * It will log either a success or failed message in the console once the fetch and execute are complete.
 */
export default function CareCheckIn() {

    useEffect(() => {
        setTimeout(() => {
            let scuiDownloadURL = process.env.REACT_APP_SCUI_BASE_URL + "/sleepcon-ui-es2015.js"

            // This will call and invoke SCUI. Either the success or failed function is called
            // to log a success or fail message in the console.
            new Promise(() => {
                const scuiScript = document.createElement('script');
                document.head.appendChild(scuiScript);
                scuiScript.onload = (() => {console.log("Successfully loaded SCUI.")})
                scuiScript.onerror = (() => {console.log("Error loading SCUI.")})
                scuiScript.async = true;
                scuiScript.src = scuiDownloadURL;
            });
        })
    }, []);

    return <div />
}